import { DashboardWidget } from "@/model/data/dashboard/DashboardWidget";
import { ApiGenericResponse } from "../../ApiGenericResponse";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../../Command";

const ENDPOINT = "/dashboard/widget";

export class CreateDashboardWidgetCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    widget: DashboardWidget;

    constructor(widget: DashboardWidget) {
        super();
        this.widget = widget;
    }

    public async execute(): Promise<ApiGenericResponse> {
        var res = await this.executeCommand(this.widget);
        return new ApiGenericResponse(res);
    }
}
